import { CircularProgress, Dialog } from '@mui/material'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import racingFlag from 'src/assets/racing_flag.png'
import successIcon from 'src/assets/successIcon.svg'
import { APP_CONSTANTS, EXTERNAL_FEATURE_TYPES } from 'src/consumer/constants'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { getFeatureItemBySlug } from 'src/consumer/services/featureServices'
import { useScreenSize } from 'src/customHooks/customHooks'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { getAllDomains } from 'src/mentor/layout/utils'
import {
  InfoAndSingleActionComponentVarOne,
  RelatedAppFeaturesComponent,
} from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import { LoadingSpinner } from '../Loaders'
import { SOMYA_ADDICTION_EVENT_URL } from '../PersonalizedPlan/BehavioralAddictionPlan'
import FaqSection from '../PrewallAndPaywall/FaqSection'
import PrewallAndPaywall from '../PrewallAndPaywall/PrewallAndPaywall'
import { FAQ_LAYOUTS } from '../PrewallAndPaywall/faqComponents/utils'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'
import {
  APCategoryCountChipsContainer,
  APDayFlagContainer,
  APDayItemEventDetailsContainer,
  APDayItemEventDetailsTitle,
  APDayItemEventParent,
  APDayItemEventPicture,
  APDayItemEventTimeContainer,
  APDayThread,
  APDescriptionContainer,
  APGoToUserActivityDialogContent,
  APGoToUserActivityDialogGoBackButton,
  APGoToUserActivityDialogHeading,
  APGoToUserActivityDialogPaper,
  APGoToUserActivityDialogProceedButton,
  APGoToUserActivityDialogSubHeading,
  APJoinNowButton,
  APJoinNowButtonContainer,
  APPDayHeading,
  APPDayItemEventsContainer,
  APPDayProgressConnectorContainer,
  APSectionContainer,
  APSectionHeading,
  APTagChips,
  ActivityPlanBackground,
  ActivityPlanHeader,
  ActivityPlanPhaseDayItemContainer,
  ActivityPlanPhaseDetailSection,
  PlanStartedSuccessIcon,
  ProceedToActivityPlanButtonsContainer,
} from './ActivityPlanPageStyles'
import { GenericHeaderBackButton } from './MyPlanComponents'
import APCategoryCountComponent from './components/APCategoryCountComponent'

export default function ActivityPlanPage({
  useId: isPlanIdNotASlug = false,
  propPlanId,
  isWebView = false,
  setupData,
  setupLoading,
  profileData,
}) {
  const { planId: urlPlanId } = useParams()
  const planId = propPlanId || urlPlanId
  const { state } = useLocation()
  const navigate = useNavigate()
  const screenSize = useScreenSize()
  const [showPaywall, setShowPaywall] = useState(false)
  const [subscriptionPlan, setSubscriptionPlan] = useState()
  const [showGoToUserActivityPage, setShowGoToUserActivityPage] = useState(false)
  const [starting, setStarting] = useState(false)
  const [planItems, setPlanItems] = useState()
  const [loading, setLoading] = useState(false)
  const [domains, setDomains] = useState([])

  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')

  function togglePrewallPaywall(planDetails) {
    setSubscriptionPlan(planDetails)
    setShowPaywall((prev) => !prev)
  }

  async function getActivityPlan() {
    // const response = await getDataWithParams('/external/activity-plan', {
    //   id: isPlanIdASlug ? null : planId,
    //   slug: isPlanIdASlug ? planId : null,
    // })
    // const response = await getDataWithParams('/external/feature', {
    //   feature: EXTERNAL_FEATURE_TYPES.activityPlan,
    //   id: isPlanIdNotASlug ? planId : null,
    //   slug: isPlanIdNotASlug ? null : planId,
    //   summaryOnly: false,
    // })
    const response = await getFeatureItemBySlug(
      EXTERNAL_FEATURE_TYPES.activityPlan,
      planId,
      !isPlanIdNotASlug,
    )
    if (response.status === 200) {
      setPlanItems(response?.data.data?.['activity-plan'])
    } else {
      navigate('/404')
    }
  }

  async function getDomains() {
    const resp = await getAllDomains()
    if (resp.status === 200) {
      setDomains(resp.data)
    }
  }

  async function Setup() {
    setLoading(true)
    const promises = [getActivityPlan(), getDomains()]

    await getActivityPlan()
    setLoading(false)
  }

  async function goToUseActivityPage() {
    const userActivityRedirect = planItems?.slug
      ? `/my-activity/${planItems?.slug}`
      : `/my-activity/id/${planItems?.id}`

    navigate(`${isWebView ? '/webview' : ''}${userActivityRedirect}`)
  }

  useEffect(() => {
    if (planId) {
      Setup()
    }
  }, [planId])

  const phases = planItems?.phaseList

  async function handleStartPlan() {
    navigate(SOMYA_ADDICTION_EVENT_URL)

    setStarting(true)
    // if (isTokenInvalidOrAbsent(localStorage.getItem('token'))) {
    //   setShowClubbedAuthModal(true)
    // } else {
    //   await handleAccept(planItems, profileData, togglePrewallPaywall, () => {
    //     setShowGoToUserActivityPage(true)
    //   })
    // }
    // setStarting(false)
  }

  function backButton() {
    window.history.back()
  }

  useEffect(() => {
    console.log({ planItems })
  }, [planItems])

  console.log({ coverImg: getImageLink(planItems?.coverImage) })

  return (
    <>
      {planItems && (
        <SEOComponent
          title={`${planItems?.title} | AUMHUM`}
          description={planItems?.description}
          image={getImageLink(planItems?.coverImage) || APP_CONSTANTS.APP_LOGO_LINK}
        />
      )}
      {loading || setupLoading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <ActivityPlanBackground>
          <ActivityPlanHeader>
            <GenericHeaderBackButton clickfunction={backButton} />
          </ActivityPlanHeader>
          <InfoAndSingleActionComponentVarOne
            headline={planItems?.title}
            mainContainerStyles={{
              minHeight: '400px',
              display: 'flex',
            }}
            image={getImageLink(planItems?.coverImage)}
            actionButtonText="Begin Test"
            // clickFunction={() => handleStartLandingPage()}
          />
          {domains &&
            domains?.length > 0 &&
            planItems?.domainIds &&
            planItems?.domainIds?.length > 0 && (
              <APSectionContainer style={{ margin: '30px 25px 0px 25px' }}>
                <APDescriptionContainer>
                  <APCategoryCountChipsContainer>
                    {planItems?.domainIds?.map((domainId, idx) => (
                      <APTagChips
                        key={idx}
                        label={domains?.find((domain) => domain?.id === domainId)?.title}
                      />
                    ))}
                  </APCategoryCountChipsContainer>
                </APDescriptionContainer>
              </APSectionContainer>
            )}
          <APSectionContainer style={{ margin: '30px 25px 0px 25px' }}>
            <APDescriptionContainer>
              {!(
                domains &&
                planItems?.domainIds &&
                planItems?.domainIds?.length > 0 &&
                setupData &&
                planItems?.countMap
              ) &&
                Object.keys(planItems?.countMap || {}).length > 0 && (
                  <APSectionHeading style={{ marginTop: '0px' }}> About this Plan</APSectionHeading>
                )}
              {planItems?.description}
            </APDescriptionContainer>
          </APSectionContainer>
          {setupData && planItems?.countMap && Object.keys(planItems?.countMap || {}).length > 0 && (
            <APSectionContainer>
              <APDescriptionContainer>
                <APSectionHeading>As part of the plan you get</APSectionHeading>
                <APCategoryCountComponent countMap={planItems?.countMap} setupData={setupData} />
              </APDescriptionContainer>
            </APSectionContainer>
          )}
          <APSectionContainer noSideMargins>
            {phases?.length > 0 && (
              <ActivityPlanPhaseDetailSection>
                <div
                  style={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '60px',
                  }}
                >
                  <APDayThread style={{ zIndex: '0', position: 'absolute', left: '18px' }} />
                  {phases?.map((phaseItem, planItemIndex, allPhaseItems) => {
                    return (
                      <ActivityPlanPhaseDayItemContainer key={planItemIndex}>
                        <APPDayProgressConnectorContainer>
                          {/* {!(planItemIndex <= 0) && <APDayThread />} */}
                          <APPDayHeading>
                            <span>Day</span> <span>{phaseItem?.firstDay}</span>
                          </APPDayHeading>
                          <APDayThread hide />
                          <APPDayHeading>
                            <span>Day</span> <span>{phaseItem?.lastDay}</span>
                          </APPDayHeading>
                        </APPDayProgressConnectorContainer>

                        <div style={{ width: '100%' }}>
                          <APPDayItemEventsContainer>
                            <APDayItemEventParent>
                              <APDayItemEventTimeContainer>
                                <span>{phaseItem?.title}</span>
                                {screenSize.width < 768 && (
                                  <APDayItemEventPicture src={getImageLink(phaseItem?.coverIcon)} />
                                )}
                              </APDayItemEventTimeContainer>
                              <APDayItemEventDetailsContainer>
                                <APDayItemEventDetailsTitle>
                                  {phaseItem?.description}
                                </APDayItemEventDetailsTitle>
                                {screenSize.width >= 768 && (
                                  <APDayItemEventPicture src={getImageLink(phaseItem?.coverIcon)} />
                                )}
                              </APDayItemEventDetailsContainer>
                            </APDayItemEventParent>
                          </APPDayItemEventsContainer>
                        </div>
                      </ActivityPlanPhaseDayItemContainer>
                    )
                  })}
                  <ActivityPlanPhaseDayItemContainer>
                    <APPDayProgressConnectorContainer>
                      <APDayFlagContainer>
                        <img src={racingFlag} style={{ width: '90%' }} alt="flag" />
                      </APDayFlagContainer>
                    </APPDayProgressConnectorContainer>
                  </ActivityPlanPhaseDayItemContainer>
                </div>
              </ActivityPlanPhaseDetailSection>
            )}
          </APSectionContainer>
          {!isWebView && (
            <APSectionContainer>
              <RelatedAppFeaturesComponent
                domainsArray={[]}
                featuresArrayInOrder={['mentor']}
                courseCategory={'therepy'}
              />
            </APSectionContainer>
          )}
          <APSectionContainer>
            <FaqSection
              categoryIds={planItems?.faqCategories}
              layoutType={FAQ_LAYOUTS.TWO_COLUMN_SIDEBAR}
            />
          </APSectionContainer>
          <APJoinNowButtonContainer>
            <APJoinNowButton disabled={starting && setupLoading} onClick={handleStartPlan}>
              {starting ? <CircularProgress sx={{ color: 'white' }} size={35} /> : 'Get This Plan'}
            </APJoinNowButton>
          </APJoinNowButtonContainer>
          <PrewallAndPaywall
            id="journal_play"
            secureData={setupData}
            wallIsOpen={showPaywall}
            toggleWall={togglePrewallPaywall}
          />
          <ClubbedAuthModal
            open={showClubbedAuthModal}
            onClose={() => {
              setShowClubbedAuthModal(false)
            }}
            loginVariant={typeOfClubbedAuthModal === 'login'}
          />
          <Dialog
            sx={{ backdropFilter: 'blur(5px)' }}
            open={showGoToUserActivityPage}
            PaperComponent={APGoToUserActivityDialogPaper}
          >
            <APGoToUserActivityDialogContent>
              <PlanStartedSuccessIcon src={successIcon} />
              <div className="d-flex flex-column justify-content-center align-items-center gap-1">
                <APGoToUserActivityDialogHeading>
                  {planItems?.title} plan has been successfully started for you.
                </APGoToUserActivityDialogHeading>
                {!isWebView && (
                  <APGoToUserActivityDialogSubHeading>
                    Do you want to go to this activity or go back to the home page?
                  </APGoToUserActivityDialogSubHeading>
                )}
              </div>
              <ProceedToActivityPlanButtonsContainer>
                {!isWebView ? (
                  <APGoToUserActivityDialogGoBackButton
                    onClick={() => {
                      navigate('/')
                    }}
                  >
                    Go to home page
                  </APGoToUserActivityDialogGoBackButton>
                ) : (
                  <APGoToUserActivityDialogGoBackButton
                    onClick={() => {
                      navigate('/webview/plan')
                    }}
                  >
                    Start More Plans
                  </APGoToUserActivityDialogGoBackButton>
                )}
                <APGoToUserActivityDialogProceedButton onClick={goToUseActivityPage}>
                  Proceed
                </APGoToUserActivityDialogProceedButton>
              </ProceedToActivityPlanButtonsContainer>
            </APGoToUserActivityDialogContent>
          </Dialog>
        </ActivityPlanBackground>
      )}
    </>
  )
}
